import React, { useCallback } from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery } from '@mui/material';

const ImageGallery = ({ video, imgColumn, imgHeight, openHandle, DOMAIN }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 移动端判断
  const handleClick = useCallback((index) => {
    openHandle(index);
  }, [openHandle]);

  const displayMedias = video.medias.slice(0, 4); // 只显示前4张
  const extraCount = video.medias.length - 4;
  const isSingle = video.medias.length === 1;

  return (
    <ImageList
      cols={isMobile ? 2 : imgColumn} // 移动端每行2个
      rowHeight={isSingle ? 105 : imgHeight} // 单张图片高度限制105px
      gap={8}
      sx={{ width: '100%', overflow: 'hidden' }}
    >
      {displayMedias.map((item, i) => (
        <ImageListItem
          key={item.fileid}
          onClick={() => handleClick(i)}
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            cursor: 'pointer',
            position: 'relative',
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.05)',
              zIndex: 2,
            },
            background: 'linear-gradient(180deg, #f0f0f0 0%, #e0e0e0 100%)',
            height: isSingle ? 200 : 'auto', // 单张图片固定高度200px
          }}
        >
          <img
            src={`${DOMAIN}miniapp/${item.fileid}.tb.jpg`}
            alt={`media-${i}`}
            loading="lazy"
            onError={(e) => {
              const fallbackUrl = `${DOMAIN}miniapp/${item.fileid}.jpg`;
              if (!e.currentTarget.dataset.error) {
                e.currentTarget.dataset.error = 'true';
                e.currentTarget.src = fallbackUrl;
              }
            }}
            onLoad={(e) => { e.currentTarget.style.opacity = 1; }}
            style={{
              width: '100%',
              height: isSingle ? '200px' : '100%', // 单张图片固定高度200px
              objectFit: isSingle ? 'contain' : 'cover',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              transition: 'opacity 0.6s ease-in-out',
              opacity: 0,
              display: 'block',
            }}
          />
          {i === 3 && extraCount > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.35)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '12px',
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                +{extraCount}
              </Typography>
            </Box>
          )}
        </ImageListItem>
      ))}
    </ImageList>
  );
};

export default React.memo(ImageGallery);
